import { render, staticRenderFns } from "./ContentImport.vue?vue&type=template&id=3c0f8484&"
import script from "./ContentImport.vue?vue&type=script&lang=js&"
export * from "./ContentImport.vue?vue&type=script&lang=js&"
import style0 from "./ContentImport.vue?vue&type=style&index=0&id=3c0f8484&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports